import axios, { AxiosPromise } from "axios";
import { FlowFile } from "../models/responses/FlowFile";

const baseURL = "/AutoConnectSSO/api/InscriptionFlow/InscriptionFlowFiles/";
const resourceBaseUrl = "/AutoConnectSSO/api/InscriptionFlow/Resources/";
const instance = axios.create({
  baseURL: baseURL,
  withCredentials: true
});

export default {
  listByFlow(flowId: number) {
    return instance.get<FlowFile[]>(`ListByFlow/${flowId}`);
  },

  deleteFlowFile(guid: string) {
    return instance.delete(`${guid}`) as AxiosPromise<FlowFile>;
  },

  createFlowFile(flowId: number, file: File) {
    const data = new FormData();
    data.append("file", file, file.name);
    return instance.post<FlowFile>(`${flowId}`, data, {
      headers: {
        "Content-Type": `multipart/form-data`
      }
    });
  },
  getDownloadUrl(flowName: number, fileName: string): string {
    return `${resourceBaseUrl}${flowName}/${fileName}`;
  }
};
